import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class TutorialService {

  constructor(private http: HttpClient) { }

  createTutorial(payload: any) {
    return this.http.post(urls.API_URL + urls.TUTORIALS, payload)
      .pipe(catchError(errorHandl));
  }

  saveTutorial(id: any, payload: any) {
    if (id) {
      return this.http.patch(urls.API_URL + urls.TUTORIALS + '/' + id, payload)
        .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.TUTORIALS, payload)
      .pipe(catchError(errorHandl));
  }

   getTutorials(queryParams: any) {
    const params = new HttpParams({fromObject: queryParams});
    return this.http.get(urls.API_URL + urls.TUTORIALS, {params})
      .pipe(catchError(errorHandl));
  }

   getById(id: any) {
    return this.http.get(urls.API_URL + urls.TUTORIALS + '/' + id)
      .pipe(catchError(errorHandl));
  }
}